// 遷移元サービス(service_id)の追跡ユーティリティ。
//
// 物件管理などログイン以外の認証ページ(パスワード忘れ等)を設定画面(このFE)へ委譲した場合、
// 遷移元アプリは `?service_id=...` を付けて設定画面の /checkmail に飛ばしてくる。
// フロー完了後、その service_id を見て「遷移前のアプリのログイン画面」へ戻す。

const STORAGE_KEY = "auth_origin_service_id";

// 遷移元サービス(service_id) → そのアプリのログインURL のマップ。env で上書き可。
// ローカル既定は物件管理FE(:3004)。将来 mst_services.base_url 等で動的化する余地あり。
const PROPERTY_SERVICE_ID =
  import.meta.env.VITE_PROPERTY_SERVICE_ID ??
  "26d0cc6a-0c56-40ea-8b1f-0f2b95440b1d";
const PROPERTY_FE_URL =
  import.meta.env.VITE_PROPERTY_FE_URL ?? "http://localhost:3004";

const ORIGIN_LOGIN_URLS: Record<string, string> = {
  [PROPERTY_SERVICE_ID]: `${PROPERTY_FE_URL}/login`,
};

/**
 * 遷移元 service_id を保存する。null/空なら何もしない。
 * localStorage を使うのは既存のパスワード忘れフロー(email 保持)に合わせるため。
 */
export const rememberOriginServiceId = (serviceId: string | null): void => {
  if (serviceId && serviceId.trim()) {
    localStorage.setItem(STORAGE_KEY, serviceId.trim());
  }
};

/** 保存済みの遷移元 service_id を取得。 */
export const getOriginServiceId = (): string | null =>
  typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;

/** 保存済みの遷移元 service_id を破棄する。 */
export const clearOriginServiceId = (): void => {
  localStorage.removeItem(STORAGE_KEY);
};

/**
 * 戻り先ログインURLを解決する。
 * 未指定/未知の service_id なら null (=設定画面自身の /login にフォールバック)。
 */
export const resolveOriginLoginUrl = (): string | null => {
  const id = getOriginServiceId();
  if (!id) return null;
  return ORIGIN_LOGIN_URLS[id] ?? null;
};
